import { ICornerPanelSource } from "./cornerPanelSource";
import { ICustomCornerSource } from "./customCornerSource";
import { ICustomPanelSource } from "./customPanelSource";
import { ICustomCornerType, ICustomPanelType, ICustomZShapeType } from "./customPanelTypes";
import { ICustomZShapedPanelSource } from "./customZShapedPanelSource";
import { IPanelGeneratedModelDto, PanelTypeGenerationStatus } from "./panelGeneratedModelDto";
import { IPanelSource } from "./panelSource";
import { IPanelType } from "./panelType";

/**
 * Union type for all possible panel source types
 */
export type PanelSourceUnion =
    | IPanelSource
    | ICornerPanelSource
    | ICustomPanelSource
    | ICustomCornerSource
    | ICustomZShapedPanelSource;

/**
 * Maps panel source types to their corresponding model types
 * Used to determine the model type for a given panel source
 */
export type PanelSourceModelType<T> =
    T extends IPanelSource | ICornerPanelSource ? IPanelType :
        T extends ICustomPanelSource ? ICustomPanelType :
            T extends ICustomCornerSource ? ICustomCornerType :
                T extends ICustomZShapedPanelSource ? ICustomZShapeType :
                    never;

/**
 * Default models for panel generation states
 */
export const PANEL_TYPE_MODELS = {
    failed: {
        id: "",
        typeId: "",
        bubble: null,
        status: PanelTypeGenerationStatus.ModelGenerationFailed,
    } as IPanelGeneratedModelDto,

    inProgress: {
        id: "",
        typeId: "",
        bubble: null,
        status: PanelTypeGenerationStatus.ModelGenerationInProgress,
    } as IPanelGeneratedModelDto,
};
